module.exports = __webpack_public_path__ + "img/imgs8.2439d856.png";